import "./icon.component.scss";

import { useTranslation } from "react-i18next";
import { memo } from "react";

const Icon = props => {
  const {
    iconTitle,
    className,
    disabled,
    onClick,
    ...other
  } = props;
  const { t } = useTranslation();

  const currentClassName = className || '';
  const currentClickClassName = onClick ? 'cursor-pointer' : '';

  return (
    <div
      title={t(iconTitle)}
      className={`icon ${currentClassName} ${currentClickClassName}`}
      disabled={disabled}
      onClick={onClick}
      {...other}
    />
  );
};

export default memo(Icon);
